module.exports = __webpack_public_path__ + "h5assets/img/guide_upload_web.e6961d7.png";